class ExternalApiService {
  async fetchAndMap<T, U>(url: string, mapper: (data: T) => U): Promise<U> {
    try {
      const response = await fetch(url)

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`)
      }

      const data: T = await response.json()

      return mapper(data)
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Error fetching data:', error)
      throw error
    }
  }
}

export default new ExternalApiService()
